import { render, staticRenderFns } from "./CreateCartItemsTable.vue?vue&type=template&id=70989f78"
import script from "./CreateCartItemsTable.vue?vue&type=script&lang=js"
export * from "./CreateCartItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70989f78')) {
      api.createRecord('70989f78', component.options)
    } else {
      api.reload('70989f78', component.options)
    }
    module.hot.accept("./CreateCartItemsTable.vue?vue&type=template&id=70989f78", function () {
      api.rerender('70989f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/create-cart-items-table/CreateCartItemsTable.vue"
export default component.exports